import React from "react";

export const PrivacyV1_0: React.FC = () => {
  return (
    <div className="p-4 sm:p-6 space-y-8 text-gray-700 leading-relaxed">
      {/* Introdução */}
      <section>
        <p>
          A Interlaced valoriza a sua privacidade. Leia atentamente nossa política de privacidade para entender como seus dados são armazenados, tratados e utilizados pela plataforma. Ao aceitar nossos Termos de Uso, Política de Privacidade e Diretrizes da Comunidade, você concorda expressamente com o tratamento dos seus dados pessoais pela Interlaced, exclusivamente para as finalidades descritas nestes documentos.
        </p>
      </section>

      {/* Seção 1 */}
      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">1 – Quem somos</h2>
        <p>
          A Interlaced é uma plataforma pertencente a Empresa VIBE CODING LTD, sediada no Brasil, na cidade de São Paulo - SP. A plataforma foi desenvolvida com o objetivo de facilitar a interação entre usuários maiores de 18 (dezoito) anos, por meio de funcionalidades que promovem conexões interpessoais baseadas em afinidade, interesses comuns e objetivos previamente definidos, sem garantir a efetividade ou continuidade dessas interações.
        </p>
      </section>

      {/* Seção 2 */}
      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">2 – A que se destina esta política de privacidade</h2>
        <p className="mb-4">
          Nossa Política de Privacidade se aplica ao nosso site, promoções, aplicativos, produtos e todos os outros serviços fornecidos pela marca Interlaced. Esta Política de Privacidade se aplica a todos os recursos, funcionalidades e serviços ofertados pela Interlaced, independentemente de como o usuário interaja com a plataforma. Para efeitos desta Política, todas essas atividades são denominadas de forma coletiva como "serviços". O tratamento de dados pessoais realizado pela Interlaced observa estritamente a legislação brasileira aplicável, incluindo a Lei Geral de Proteção de Dados (Lei nº 13.709/18 – LGPD) e o Marco Civil da Internet (Lei nº 12.965/14 – MCI), priorizando a transparência, a segurança e a proteção dos direitos dos titulares.
        </p>
        <p>
          Se algum serviço específico da Interlaced exigir uma política de privacidade própria, você será informado e a respectiva política será disponibilizada para consulta, passando a prevalecer sobre esta Política de Privacidade exclusivamente para aquele serviço.
        </p>
      </section>

      {/* Seção 3 */}
      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">3 – Dados que coletamos</h2>
        <p className="mb-4">
          Para que você possa alcançar seus objetivos na plataforma e interagir com outros usuários, é necessário fornecer determinados dados pessoais no momento do cadastro. A ausência dessas informações essenciais impossibilitará o uso integral dos serviços oferecidos pela Interlaced, bem como inviabilizará nossa capacidade de facilitar as conexões desejadas. Caso deseje mais detalhes, consulte a tabela abaixo, que apresenta as categorias de dados pessoais que coletamos para garantir o funcionamento adequado da plataforma.
        </p>

        {/* Tabela Desktop */}
        <div className="hidden sm:block overflow-x-auto">
          <table className="w-full border-collapse border border-gray-300">
            <thead className="bg-gray-100">
              <tr>
                <th className="border border-gray-300 p-3 text-left font-semibold">Categorias</th>
                <th className="border border-gray-300 p-3 text-left font-semibold">Descrição</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 p-3 font-medium">Dados da Conta</td>
                <td className="border border-gray-300 p-3">
                  Ao se cadastrar na plataforma da Interlaced, você fornece a nós suas informações básicas para a configuração da sua conta, tais como: data de nascimento, e-mail, telefone.
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3 font-medium">Dados do Perfil</td>
                <td className="border border-gray-300 p-3">
                  Quando você preenche os dados do seu perfil, incluindo nome, sobrenome, gênero, preferências, biografia, hobbies e localização aproximada, você compartilha informações pessoais adicionais. Alguns desses dados podem ser considerados sensíveis, como orientação sexual, saúde, vida sexual ou filiações políticas, sendo tratados com sigilo e restrição de acesso conforme a legislação aplicável. Ao fornecer essas informações, você concorda que a Interlaced as utilizará conforme estabelecido nesta Política de Privacidade, comprometendo-se a protegê-las com as medidas adequadas de segurança e privacidade.
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3 font-medium">Conteúdo</td>
                <td className="border border-gray-300 p-3">
                  Você poderá utilizar a plataforma para publicar fotos, áudios, mensagens em texto e outros tipos de conteúdo, incluindo suas conversas com outros usuários, desde que tais publicações não violem os Termos de Uso.
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3 font-medium">Dados de compra</td>
                <td className="border border-gray-300 p-3">
                  Ao assinar nosso serviço ou adquirir itens avulsos, coletamos os detalhes da sua operação, tais como data da compra, número do pedido, forma de pagamento, descrição dos produtos adquiridos e o valor pago. A exatidão das informações fornecidas pode variar conforme o método de pagamento escolhido. Nas compras realizadas na plataforma por meio de cartão de crédito, débito ou Pix, recebemos os dados necessários para processar a transação, incluindo números e demais informações financeiras pertinentes.
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3 font-medium">Dados utilizados em atividades de marketing e pesquisa</td>
                <td className="border border-gray-300 p-3">
                  Periodicamente, realizamos pesquisas, grupos focais e estudos de mercado para análise, bem como promoções, eventos e concursos com finalidades de marketing. Ao participar dessas atividades, você nos fornece as informações necessárias para o processamento do seu cadastro e participação, incluindo suas respostas e comentários.
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3 font-medium">Dados de terceiros</td>
                <td className="border border-gray-300 p-3">
                  Quando você compartilha informações sobre outros usuários, como ao enviar denúncias ou consultas relacionadas a determinado usuário, utilizamos os dados fornecidos para processar a solicitação em seu nome, com o objetivo de atender e concluir o seu pedido.
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3 font-medium">Dados de suporte ao cliente</td>
                <td className="border border-gray-300 p-3">
                  Ao entrar em contato com o suporte ao usuário, você fornecerá informações necessárias para que possamos auxiliar na solução de suas dúvidas ou problemas. É importante destacar que, em algumas situações, outras pessoas poderão encaminhar solicitações ou denúncias relativas a você. Nesse caso, nossa equipe, bem como as ferramentas de moderação da plataforma, poderá coletar dados adicionais durante o processo de apuração. Quando permitido por lei, também podemos receber informações provenientes de terceiros relacionadas a suspeitos ou indivíduos envolvidos em atividades criminais, como parte dos nossos esforços para garantir a segurança e proteção dos membros da plataforma.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Tabela Mobile (Cards) */}
        <div className="sm:hidden space-y-4">
          <div className="border border-gray-300 rounded-lg p-4 bg-gray-50">
            <h3 className="font-semibold text-gray-900 mb-2">Dados da Conta</h3>
            <p className="text-sm">Ao se cadastrar na plataforma da Interlaced, você fornece a nós suas informações básicas para a configuração da sua conta, tais como: data de nascimento, e-mail, telefone.</p>
          </div>

          <div className="border border-gray-300 rounded-lg p-4 bg-gray-50">
            <h3 className="font-semibold text-gray-900 mb-2">Dados do Perfil</h3>
            <p className="text-sm">Quando você preenche os dados do seu perfil, incluindo nome, sobrenome, gênero, preferências, biografia, hobbies e localização aproximada, você compartilha informações pessoais adicionais. Alguns desses dados podem ser considerados sensíveis, como orientação sexual, saúde, vida sexual ou filiações políticas, sendo tratados com sigilo e restrição de acesso conforme a legislação aplicável.</p>
          </div>

          <div className="border border-gray-300 rounded-lg p-4 bg-gray-50">
            <h3 className="font-semibold text-gray-900 mb-2">Conteúdo</h3>
            <p className="text-sm">Você poderá utilizar a plataforma para publicar fotos, áudios, mensagens em texto e outros tipos de conteúdo, incluindo suas conversas com outros usuários, desde que tais publicações não violem os Termos de Uso.</p>
          </div>

          <div className="border border-gray-300 rounded-lg p-4 bg-gray-50">
            <h3 className="font-semibold text-gray-900 mb-2">Dados de compra</h3>
            <p className="text-sm">Ao assinar nosso serviço ou adquirir itens avulsos, coletamos os detalhes da sua operação, tais como data da compra, número do pedido, forma de pagamento, descrição dos produtos adquiridos e o valor pago.</p>
          </div>

          <div className="border border-gray-300 rounded-lg p-4 bg-gray-50">
            <h3 className="font-semibold text-gray-900 mb-2">Dados utilizados em atividades de marketing e pesquisa</h3>
            <p className="text-sm">Periodicamente, realizamos pesquisas, grupos focais e estudos de mercado para análise, bem como promoções, eventos e concursos com finalidades de marketing.</p>
          </div>

          <div className="border border-gray-300 rounded-lg p-4 bg-gray-50">
            <h3 className="font-semibold text-gray-900 mb-2">Dados de terceiros</h3>
            <p className="text-sm">Quando você compartilha informações sobre outros usuários, como ao enviar denúncias ou consultas relacionadas a determinado usuário, utilizamos os dados fornecidos para processar a solicitação em seu nome.</p>
          </div>

          <div className="border border-gray-300 rounded-lg p-4 bg-gray-50">
            <h3 className="font-semibold text-gray-900 mb-2">Dados de suporte ao cliente</h3>
            <p className="text-sm">Ao entrar em contato com o suporte ao usuário, você fornecerá informações necessárias para que possamos auxiliar na solução de suas dúvidas ou problemas.</p>
          </div>
        </div>

        {/* Subseção 3.1 */}
        <h3 className="text-lg font-semibold mt-6 mb-3 text-gray-800">3.1 – Dados gerados ou coletados automaticamente</h3>

        {/* Tabela Desktop 3.1 */}
        <div className="hidden sm:block overflow-x-auto">
          <table className="w-full border-collapse border border-gray-300">
            <thead className="bg-gray-100">
              <tr>
                <th className="border border-gray-300 p-3 text-left font-semibold">Categorias de dados</th>
                <th className="border border-gray-300 p-3 text-left font-semibold">Descrição</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 p-3 font-medium">Dados de uso</td>
                <td className="border border-gray-300 p-3">
                  Quando você acessa nossos serviços, são gerados dados relativos às suas atividades e à forma como utiliza a plataforma. Por exemplo, ao realizar login, suas informações são enviadas aos nossos servidores para validação; ao realizar ações na plataforma, como se comunicar com outros usuários, pesquisar perfis, curtir conteúdos ou interagir com anúncios. Também é possível que informações sobre sua atividade sejam capturadas quando você interage com anúncios da Interlaced presentes em páginas ou aplicativos de terceiros, permitindo o aprimoramento dos nossos serviços e campanhas.
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3 font-medium">Dados biométricos faciais</td>
                <td className="border border-gray-300 p-3">
                  Alguns recursos da plataforma, como verificação de foto ou autenticação por imagem, podem exigir, caso seja de seu interesse utilizá-los, a captura e análise de dados relativos às características do seu rosto. Dependendo da legislação local, essas informações podem ser consideradas dados biométricos.
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3 font-medium">Dados de identificação</td>
                <td className="border border-gray-300 p-3">
                  Você poderá nos fornecer uma cópia do seu documento de identidade emitido por autoridade governamental, para que possamos verificar a sua identidade de forma segura. Esse processo inclui a validação do documento apresentado, a fim de atestar a autenticidade e confirmar que o usuário cumpre os requisitos legais aplicáveis.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Tabela Mobile 3.1 (Cards) */}
        <div className="sm:hidden space-y-4">
          <div className="border border-gray-300 rounded-lg p-4 bg-gray-50">
            <h3 className="font-semibold text-gray-900 mb-2">Dados de uso</h3>
            <p className="text-sm">Quando você acessa nossos serviços, são gerados dados relativos às suas atividades e à forma como utiliza a plataforma.</p>
          </div>

          <div className="border border-gray-300 rounded-lg p-4 bg-gray-50">
            <h3 className="font-semibold text-gray-900 mb-2">Dados biométricos faciais</h3>
            <p className="text-sm">Alguns recursos da plataforma, como verificação de foto ou autenticação por imagem, podem exigir a captura e análise de dados relativos às características do seu rosto.</p>
          </div>

          <div className="border border-gray-300 rounded-lg p-4 bg-gray-50">
            <h3 className="font-semibold text-gray-900 mb-2">Dados de identificação</h3>
            <p className="text-sm">Você poderá nos fornecer uma cópia do seu documento de identidade emitido por autoridade governamental, para que possamos verificar a sua identidade de forma segura.</p>
          </div>
        </div>
      </section>

      {/* Seção 4 */}
      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">4 – Motivos e Formas de Utilização dos Seus Dados Pessoais</h2>
        <p className="mb-4">
          Para assegurar o funcionamento contínuo do serviço e atender às expectativas dos usuários, dedicamo-nos a aprimorar constantemente a plataforma. Nosso objetivo é possibilitar que você estabeleça novas conexões e alcance seus propósitos dentro da Interlaced, proporcionando a melhor experiência possível e o máximo aproveitamento dos recursos disponíveis. Também utilizamos seus dados para garantir a segurança de todos os membros enquanto utilizam nossos serviços. Assumimos essa responsabilidade com extrema seriedade e dedicamos esforços contínuos para aprimorar nossos sistemas e processos visando sua proteção.
        </p>

        {/* Tabela Desktop Seção 4 */}
        <div className="hidden sm:block overflow-x-auto">
          <table className="w-full border-collapse border border-gray-300">
            <thead className="bg-gray-100">
              <tr>
                <th className="border border-gray-300 p-3 text-left font-semibold">Objetivos do processamento</th>
                <th className="border border-gray-300 p-3 text-left font-semibold">Fundamentos jurídicos</th>
                <th className="border border-gray-300 p-3 text-left font-semibold">Classificação dos dados</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 p-3">
                  <strong>Autorizar sua interação com o serviço:</strong>
                  <ul className="list-disc pl-5 mt-2 space-y-1">
                    <li>Criação e manutenção de sua conta e perfil</li>
                    <li>Possibilitar funcionamento dos recursos</li>
                    <li>Recomendar usuários</li>
                    <li>Realizar sorteios e promoções</li>
                    <li>Sanar dúvidas e solicitações de suporte</li>
                    <li>Monitorar desempenho e resolver problemas</li>
                  </ul>
                </td>
                <td className="border border-gray-300 p-3">
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Cumprimento e execução das obrigações contratuais</li>
                    <li>Consentimento para dados sensíveis</li>
                  </ul>
                </td>
                <td className="border border-gray-300 p-3">
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Dados da conta</li>
                    <li>Dados do perfil</li>
                    <li>Conteúdo compartilhado</li>
                    <li>Dados de compra</li>
                    <li>Dados de marketing</li>
                    <li>Dados de terceiros</li>
                    <li>Dados de suporte</li>
                    <li>Dados de redes sociais</li>
                    <li>Dados de uso</li>
                    <li>Dados técnicos</li>
                    <li>Dados de geolocalização</li>
                    <li>Dados biométricos faciais</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3">
                  <strong>Realizar compras:</strong>
                  <ul className="list-disc pl-5 mt-2 space-y-1">
                    <li>Processar pagamentos</li>
                    <li>Oferecer descontos e promoções</li>
                    <li>Ajustar preços personalizados</li>
                  </ul>
                </td>
                <td className="border border-gray-300 p-3">Cumprimento e execução das obrigações contratuais</td>
                <td className="border border-gray-300 p-3">
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Dados da conta</li>
                    <li>Dados do perfil</li>
                    <li>Dados técnicos</li>
                    <li>Dados de compra</li>
                    <li>Dados de uso</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3">
                  <strong>Campanhas publicitárias e marketing:</strong>
                  <ul className="list-disc pl-5 mt-2 space-y-1">
                    <li>Avaliar resultados de campanhas</li>
                    <li>Compartilhar informações relevantes</li>
                    <li>Otimizar performance</li>
                  </ul>
                </td>
                <td className="border border-gray-300 p-3">
                  Consentimento (quando exigido) ou interesse legítimo
                </td>
                <td className="border border-gray-300 p-3">
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Dados da conta</li>
                    <li>Dados do perfil</li>
                    <li>Dados técnicos</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3">
                  <strong>Segurança dos usuários:</strong>
                  <ul className="list-disc pl-5 mt-2 space-y-1">
                    <li>Combater fraudes e atividades ilícitas</li>
                    <li>Prevenir violações aos Termos</li>
                    <li>Evitar reincidências</li>
                    <li>Verificar identidade</li>
                    <li>Garantir segurança de pagamentos</li>
                    <li>Fornecer retorno sobre denúncias</li>
                  </ul>
                </td>
                <td className="border border-gray-300 p-3">
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Cumprimento de obrigações contratuais</li>
                    <li>Proteção de interesses essenciais</li>
                    <li>Cumprimento de obrigações legais</li>
                  </ul>
                </td>
                <td className="border border-gray-300 p-3">
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Dados da conta</li>
                    <li>Dados do perfil</li>
                    <li>Conteúdo compartilhado</li>
                    <li>Dados de compra</li>
                    <li>Dados de marketing</li>
                    <li>Dados de terceiros</li>
                    <li>Dados de suporte</li>
                    <li>Dados de redes sociais</li>
                    <li>Dados de uso</li>
                    <li>Dados técnicos</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3">
                  <strong>Obrigações legais:</strong>
                  <ul className="list-disc pl-5 mt-2 space-y-1">
                    <li>Atender exigências legais</li>
                    <li>Instaurar e defender direitos judiciais</li>
                    <li>Atender obrigações judiciais</li>
                    <li>Proteger interesses da comunidade</li>
                    <li>Oferecer suporte a investigações</li>
                    <li>Reportar conteúdos ilícitos</li>
                  </ul>
                </td>
                <td className="border border-gray-300 p-3">
                  <ul className="list-disc pl-5 space-y-1">
                    <li>Interesse legítimo</li>
                    <li>Proteção de interesses essenciais</li>
                  </ul>
                </td>
                <td className="border border-gray-300 p-3">Todos os dados coletados</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Tabela Mobile Seção 4 (Cards) */}
        <div className="sm:hidden space-y-4">
          <div className="border border-gray-300 rounded-lg p-4 bg-gray-50">
            <h3 className="font-semibold text-gray-900 mb-2">Autorizar sua interação com o serviço</h3>
            <p className="text-sm mb-2"><strong>Fundamentos:</strong> Cumprimento de obrigações contratuais e consentimento</p>
            <p className="text-sm"><strong>Dados:</strong> Conta, perfil, conteúdo, compra, marketing, terceiros, suporte, redes sociais, uso, técnicos, geolocalização, biometria</p>
          </div>

          <div className="border border-gray-300 rounded-lg p-4 bg-gray-50">
            <h3 className="font-semibold text-gray-900 mb-2">Realizar compras</h3>
            <p className="text-sm mb-2"><strong>Fundamentos:</strong> Cumprimento de obrigações contratuais</p>
            <p className="text-sm"><strong>Dados:</strong> Conta, perfil, técnicos, compra, uso</p>
          </div>

          <div className="border border-gray-300 rounded-lg p-4 bg-gray-50">
            <h3 className="font-semibold text-gray-900 mb-2">Campanhas publicitárias e marketing</h3>
            <p className="text-sm mb-2"><strong>Fundamentos:</strong> Consentimento ou interesse legítimo</p>
            <p className="text-sm"><strong>Dados:</strong> Conta, perfil, técnicos</p>
          </div>

          <div className="border border-gray-300 rounded-lg p-4 bg-gray-50">
            <h3 className="font-semibold text-gray-900 mb-2">Segurança dos usuários</h3>
            <p className="text-sm mb-2"><strong>Fundamentos:</strong> Obrigações contratuais, proteção de interesses, obrigações legais</p>
            <p className="text-sm"><strong>Dados:</strong> Conta, perfil, conteúdo, compra, marketing, terceiros, suporte, redes sociais, uso, técnicos</p>
          </div>

          <div className="border border-gray-300 rounded-lg p-4 bg-gray-50">
            <h3 className="font-semibold text-gray-900 mb-2">Obrigações legais</h3>
            <p className="text-sm mb-2"><strong>Fundamentos:</strong> Interesse legítimo, proteção de interesses essenciais</p>
            <p className="text-sm"><strong>Dados:</strong> Todos os dados coletados</p>
          </div>
        </div>
      </section>

      {/* Seção 5 */}
      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">5 – Compartilhamento de Dados: Nossa Abordagem</h2>
        <p className="mb-4">
          A Interlaced tem como missão facilitar que os usuários descubram e criem conexões relevantes dentro da plataforma. Por isso, as informações que você compartilha estarão visíveis para outros membros, assim como os dados deles poderão ser acessados por você. Além disso, o intercâmbio de informações poderá acontecer com nossos parceiros e prestadores de serviços que colaboram na operação da plataforma.
        </p>

        {/* Tabela Desktop Seção 5 */}
        <div className="hidden sm:block overflow-x-auto">
          <table className="w-full border-collapse border border-gray-300">
            <thead className="bg-gray-100">
              <tr>
                <th className="border border-gray-300 p-3 text-left font-semibold">Destinatários</th>
                <th className="border border-gray-300 p-3 text-left font-semibold">Razões para o compartilhamento</th>
                <th className="border border-gray-300 p-3 text-left font-semibold">Classificação dos dados</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 p-3 font-medium">Outros usuários</td>
                <td className="border border-gray-300 p-3">
                  Ao divulgar informações voluntariamente na plataforma, você está compartilhando dados com outros membros, tornando-os visíveis em seu perfil público. Se recebermos uma denúncia que envolva você, poderemos informar o denunciante sobre as providências tomadas.
                </td>
                <td className="border border-gray-300 p-3">
                  <ul className="list-disc pl-5">
                    <li>Dados da conta</li>
                    <li>Dados do perfil</li>
                    <li>Conteúdo compartilhado</li>
                    <li>Dados de redes sociais</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3 font-medium">Prestadores de serviços / parceiros</td>
                <td className="border border-gray-300 p-3">
                  Compartilhamos dados com fornecedores e parceiros que colaboram para manter, aprimorar e expandir nosso serviço em áreas-chave como hospedagem, gestão de dados, análises, suporte, marketing, publicidade, processamento de pagamentos, assessoria jurídica e segurança operacional.
                </td>
                <td className="border border-gray-300 p-3">Todos os dados coletados</td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3 font-medium">Autoridades judiciais</td>
                <td className="border border-gray-300 p-3">
                  Suas informações poderão ser divulgadas para atender a exigências legais, como ordens judiciais, intimações, mandados de busca ou investigações; apoiar a prevenção de atividades ilícitas; garantir a proteção de pessoas; além de possibilitar a proposição, defesa ou contestação em processos judiciais.
                </td>
                <td className="border border-gray-300 p-3">
                  <ul className="list-disc pl-5">
                    <li>Dados da conta</li>
                    <li>Dados do perfil</li>
                    <li>Conteúdo compartilhado</li>
                    <li>Dados de suporte</li>
                    <li>Dados de redes sociais</li>
                    <li>Dados de uso</li>
                    <li>Dados técnicos</li>
                    <li>Dados de geolocalização</li>
                    <li>Dados biométricos</li>
                    <li>Dados de identificação</li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3 font-medium">Afiliadas ou novos controladores</td>
                <td className="border border-gray-300 p-3">
                  No contexto de fusões, aquisições ou mudanças na estrutura societária, podemos compartilhar dados com afiliadas ou novos controladores, sempre visando garantir a continuidade e qualidade dos serviços prestados.
                </td>
                <td className="border border-gray-300 p-3">Todos os dados coletados</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Tabela Mobile Seção 5 (Cards) */}
        <div className="sm:hidden space-y-4">
          <div className="border border-gray-300 rounded-lg p-4 bg-gray-50">
            <h3 className="font-semibold text-gray-900 mb-2">Outros usuários</h3>
            <p className="text-sm mb-2">Ao divulgar informações voluntariamente na plataforma, você está compartilhando dados com outros membros.</p>
            <p className="text-sm"><strong>Dados:</strong> Conta, perfil, conteúdo, redes sociais</p>
          </div>

          <div className="border border-gray-300 rounded-lg p-4 bg-gray-50">
            <h3 className="font-semibold text-gray-900 mb-2">Prestadores de serviços / parceiros</h3>
            <p className="text-sm mb-2">Colaboram para manter e expandir nosso serviço em áreas como hospedagem, análises, suporte, marketing.</p>
            <p className="text-sm"><strong>Dados:</strong> Todos os dados coletados</p>
          </div>

          <div className="border border-gray-300 rounded-lg p-4 bg-gray-50">
            <h3 className="font-semibold text-gray-900 mb-2">Autoridades judiciais</h3>
            <p className="text-sm mb-2">Para atender exigências legais, ordens judiciais e investigações.</p>
            <p className="text-sm"><strong>Dados:</strong> Conta, perfil, conteúdo, suporte, redes sociais, uso, técnicos, geolocalização, biometria, identificação</p>
          </div>

          <div className="border border-gray-300 rounded-lg p-4 bg-gray-50">
            <h3 className="font-semibold text-gray-900 mb-2">Afiliadas ou novos controladores</h3>
            <p className="text-sm mb-2">Em caso de fusões, aquisições ou mudanças na estrutura societária.</p>
            <p className="text-sm"><strong>Dados:</strong> Todos os dados coletados</p>
          </div>
        </div>
      </section>

      {/* Seção 6 */}
      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">6 – Seus direitos ao utilizar os serviços da Interlaced</h2>
        <p className="mb-4">
          Ao usar nossa plataforma, você mantém o controle total sobre suas informações pessoais. Por isso, é fundamental estar ciente dos seus direitos, conhecer as ferramentas disponíveis e explorar todas as opções oferecidas para garantir a proteção dos seus dados.
        </p>

        <div className="space-y-4">
          <div>
            <h3 className="text-lg font-semibold mb-2 text-gray-800">Acesso aos seus dados</h3>
            <p>
              Você pode acessar seus dados, solicitar a transferência para outro serviço e saber quais informações temos sobre você. Você tem acesso direto para ver e revisar seus dados fazendo login na sua conta. Também pode solicitar uma cópia deles enviando um e-mail para: <a href="mailto:contato@interlaced.app" className="text-luxury-mediumPink hover:text-luxury-darkPink underline">contato@interlaced.app</a>.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-2 text-gray-800">Atualização, retificação ou correção de dados</h3>
            <p>
              Você tem o direito de corrigir ou atualizar seus dados pessoais caso estejam incorretos ou incompletos. Você pode atualizar seus dados direto no seu perfil. Para corrigir outras informações, entre em contato com nosso time de suporte através do e-mail <a href="mailto:contato@interlaced.app" className="text-luxury-mediumPink hover:text-luxury-darkPink underline">contato@interlaced.app</a>.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-2 text-gray-800">Supressão ou exclusão dos seus dados</h3>
            <p>
              Você tem o direito de apagar seus dados pessoais. Você pode excluir parte dos dados fornecidos diretamente no serviço e desativar sua conta pelo site. Para a exclusão definitiva dos seus dados ou exportação das informações, é necessário entrar em contato com nosso suporte através do e-mail: <a href="mailto:contato@interlaced.app" className="text-luxury-mediumPink hover:text-luxury-darkPink underline">contato@interlaced.app</a>.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-2 text-gray-800">Oposição ou restrição</h3>
            <p>
              Você pode se opor ao uso dos seus dados pessoais ou pedir que o processamento deles seja pausado ou interrompido, seja temporariamente ou permanentemente. Caso queira se opor ou restringir o uso dos seus dados conforme esta Política de Privacidade, entre em contato com nosso suporte pelo e-mail: <a href="mailto:contato@interlaced.app" className="text-luxury-mediumPink hover:text-luxury-darkPink underline">contato@interlaced.app</a>.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-2 text-gray-800">Revogação do consentimento</h3>
            <p>
              Você pode revogar o consentimento que nos deu para usar seus dados em uma finalidade específica a qualquer momento. Para isso, basta atualizar as configurações da sua conta ou revogar as permissões diretamente no seu dispositivo (por exemplo, acesso a contatos, fotos, localização). Se revogar o consentimento, algumas funcionalidades poderão ficar limitadas. Para mais informações, entre em contato com nosso suporte.
            </p>
          </div>
        </div>

        <p className="mt-4">
          Para garantir sua segurança e a de toda a comunidade Interlaced, podemos solicitar que você confirme sua identidade ou autorização antes de atender a algumas solicitações. Isso evita que outras pessoas tenham controle indevido sobre seus dados. Em alguns casos, podemos recusar pedidos se não conseguirmos verificar sua identidade, se a solicitação for ilegal, inválida ou se envolver segredos comerciais, propriedade intelectual, privacidade ou direitos de terceiros. Se quiser informações sobre outro membro, como cópias de mensagens recebidas, essa pessoa precisará fazer o pedido diretamente conosco pelo e-mail: <a href="mailto:contato@interlaced.app" className="text-luxury-mediumPink hover:text-luxury-darkPink underline">contato@interlaced.app</a>.
        </p>
      </section>

      {/* Seção 7 */}
      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">7 – Por quanto tempo guardamos suas informações</h2>
        <p className="mb-4">
          Nosso maior propósito é que as conexões feitas na Interlaced sejam duradouras. Porém, mantemos seus dados pessoais apenas pelo tempo necessário para atender nossas finalidades comerciais legítimas e garantir uma experiência segura e eficiente para todos. Ao final desse período, tomamos todas as medidas para eliminar ou anonimizar seus dados, protegendo sua privacidade e respeitando as melhores práticas de segurança da informação.
        </p>

        <p className="mb-4">
          Caso você decida excluir sua conta na plataforma, de forma definitiva, você pode solicitar ao nosso time de suporte a exclusão através do e-mail: <a href="mailto:contato@interlaced.app" className="text-luxury-mediumPink hover:text-luxury-darkPink underline">contato@interlaced.app</a>. É importante frisar que procederemos com a exclusão da sua conta e todos os seus dados automaticamente em caso de inatividade por 12 (doze) meses.
        </p>

        <p className="mb-4">Dessa forma, com o encerramento da sua conta, excluiremos todos os seus dados, conforme detalhado abaixo:</p>

        <ul className="list-disc pl-6 space-y-3">
          <li>
            <strong>a)</strong> Para proteger a segurança dos nossos usuários, adotamos um período de retenção de dados que se estende até 06 (seis) meses após o encerramento da conta, ou até 01 (um) ano em caso de banimento. Durante esse intervalo, mantemos as informações para apurar eventuais condutas ilegais ou prejudiciais. Essa abordagem se fundamenta no nosso legítimo interesse em garantir a segurança e integridade da plataforma, ao mesmo tempo em que protegemos os direitos e a segurança das vítimas ou de qualquer outra parte envolvida.
          </li>
          <li>
            <strong>b)</strong> Mantemos apenas os dados essenciais pelo tempo necessário para cumprir nossas obrigações internas e garantir um serviço seguro e eficiente. Informações relacionadas a operações financeiras são preservadas por até 05 (cinco) anos para permitir a análise de eventuais questionamentos. Dados de cartão de crédito continuam disponíveis enquanto houver possibilidade de contestação da operação. Já os registros de atividades e tráfego são mantidos por um ano para garantir o funcionamento adequado da plataforma. Além disso, conservamos os registros dos consentimentos fornecidos pelos usuários por 05 (cinco) anos, para assegurar que suas preferências sejam respeitadas.
          </li>
          <li>
            <strong>c)</strong> Guardamos suas informações apenas pelo tempo que for necessário para manter nosso serviço funcionando bem e assegurar a proteção de todos os usuários. Por exemplo, mantemos registros de quando interagimos com você pelo prazo de 05 (cinco) anos, para garantir um suporte eficiente e transparente. Dados relacionados a atendimentos, além de informações aproximadas de localização sobre downloads e compras, ficam guardados por 05 (cinco) anos para ajudar na segurança da plataforma. Informações sobre suas contas e assinaturas passadas são eliminadas 03 (três) anos depois do encerramento para garantir que nossos registros financeiros estejam sempre em dia. Seu perfil permanece ativo nos nossos arquivos por 01 (um) ano, caso seja necessário para questões legais. Por fim, conservamos dados que nos ajudam a impedir que usuários bloqueados voltem a criar contas, pelo tempo que for preciso para manter a comunidade protegida.
          </li>
          <li>
            <strong>d)</strong> Em situações específicas, conservamos suas informações com base em razões legítimas quando enfrentamos problemas, disputas ou questões pendentes que exigem a manutenção dos dados. Isso acontece, por exemplo, quando recebemos uma ordem judicial ou solicitação oficial para preservar informações, situação em que precisamos cumprir com determinações legais. Da mesma forma, mantemos os dados quando são necessários para processos em andamento, garantindo que possamos responder adequadamente a questões judiciais ou administrativas que envolvam nossa plataforma e usuários.
          </li>
        </ul>
      </section>

      {/* Seção 8 */}
      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">8 – Proibição e proteção de crianças</h2>
        <p className="mb-4">
          A Interlaced é destinada exclusivamente a usuários com 18 anos completos ou mais. Não permitimos o acesso de crianças ou adolescentes à nossa plataforma, incluindo menores emancipados, independentemente da supervisão de responsáveis ou situação jurídica. Além disso, é estritamente proibido compartilhar, publicar ou divulgar qualquer conteúdo que envolva menores de idade, incluindo fotos, vídeos, informações pessoais ou qualquer material relacionado a crianças e adolescentes. Esta proibição visa proteger a privacidade e segurança deste público vulnerável.
        </p>
        <p>
          Se você suspeitar que algum usuário seja menor de 18 anos ou que esteja compartilhando conteúdo envolvendo menores, reporte imediatamente através dos nossos canais de denúncia. Contas que violem esta política serão suspensas permanentemente, e os casos serão comunicados às autoridades competentes quando necessário. A proteção de crianças e adolescentes é uma responsabilidade que levamos extremamente a sério.
        </p>
      </section>

      {/* Seção 9 */}
      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">9 – Mudanças nesta Política de Privacidade</h2>
        <p>
          Podemos atualizar esta Política de Privacidade a qualquer momento para refletir mudanças legais, aprimorar nossa transparência ou melhorar seu uso da Interlaced. Sempre que introduzirmos alterações que impactem significativamente a forma como tratamos seus dados ou seus direitos, você receberá um aviso prévio de pelo menos 30 dias por e-mail ou notificação no app. Durante esse período, terá tempo de revisar as novidades e decidir se aceita os novos termos. Caso opte por não concordar, poderá encerrar sua conta antes que as mudanças entrem em vigor, sem afetar seu acesso aos serviços atuais até a data de vigência.
        </p>
      </section>

      {/* Seção 10 */}
      <section>
        <h2 className="text-xl font-semibold mb-3 text-gray-900">10 – Como entrar em contato com a Interlaced</h2>
        <p>
          Se tiver dúvidas, sugestões ou reclamações, entre em contato conosco pelo e-mail <a href="mailto:contato@interlaced.app" className="text-luxury-mediumPink hover:text-luxury-darkPink underline">contato@interlaced.app</a>. Estamos comprometidos em oferecer um canal direto e transparente para todos os usuários.
        </p>
      </section>

      {/* Rodapé */}
      <footer className="pt-6 border-t border-gray-200 text-sm text-gray-500">
        <p>Versão 1.0 — 20 de Janeiro de 2025</p>
      </footer>
    </div>
  );
};
